<div class="acc-order-details">
  <div class="row account-overview-header">
    <div class="col-xs-4 col-sm-5 col-md-7">
      <h3 class="orders">{{ "accountOrders.title" | cxTranslate }}</h3>
    </div>
    <div class="col-xs-4 col-sm-5 col-md-5">
      <p class="recent-orders">10 MOST RECENT ORDERS</p>
    </div>
  </div>
  <app-loader *ngIf="!isLoadingDone"></app-loader>
  <div class="text-center no-orders" *ngIf="!!ordersList && ordersList.length === 0 && isLoadingDone">
    {{ "accountOrders.no_orders_found" | cxTranslate }}
  </div>

  <section class="payment-section" *ngIf="!!ordersList && ordersList.length > 0 && isLoadingDone">
    <!--table starts-->
    <table aria-describedby="creditsTable" id="applyCreditsTable" class="credits-table table table-striped">
      <thead>
        <tr>
          <th scope="col" (click)="sortColumn($event, 'placed', ordersList, 'Date')">
            {{ "accountOrders.date_label" | cxTranslate }}&nbsp;
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="sortColumn($event, 'code', ordersList, 'normal')">
            Type
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="sortColumn($event, 'code', ordersList, 'normal')">
            {{ "accountOrders.order_no_label" | cxTranslate }}
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="sortColumn($event, 'code', ordersList, 'normal')">
            Account #
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="sortColumn($event, 'status', ordersList, 'normal')">
            {{ "accountOrders.order_status_label" | cxTranslate }}
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="
              sortColumn($event, 'purchaseOrderNumber', ordersList, 'normal')
            ">
            {{ "accountOrders.order_po_num_label" | cxTranslate }}
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="sortColumn($event, 'code', ordersList, 'normal')">
            Invoice #
            <i class="my-icon fas fa-caret-down"></i>
          </th>
          <th scope="col" (click)="sortColumn($event, 'shipToId', ordersList, 'normal')">
            Tracking #
            <i class="my-icon fas fa-caret-down"></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of ordersList; let i = index">
          <td>
            <span>{{ data.createdOn }}</span>
          </td>
          <td class="status-txt">
            <span> {{ data?.orderType }} </span>
          </td>
          <td>
            <a *ngIf="data.statusDisplay!='Cancelled';else cancelledOrder"
              [routerLink]="['/my-account/order', data?.code]" href="javascript: void(0);">
              {{ data.code }}</a>
            <ng-template #cancelledOrder>
              {{ data.code }}
            </ng-template>
          </td>
          <td class="status-txt">
            <span>{{ data.shipToId }} </span>
          </td>
          <td class="status-txt">
            <span>{{ data.statusDisplay }} </span>
          </td>
          <td>
            <span class="po-size">{{ data.purchaseOrderNumber }}</span>
          </td>
          <td class="status-txt">
            <div *ngFor="let invoice of data.invoices">
              <span *ngIf="asmStringCheck(invoice.invoiceNumber); else notAsmUser">{{invoice.invoiceNumber
                }}</span>
              <ng-template #notAsmUser>
                <a (click)="downloadInvoice(invoice?.encryptedInvoiceNumber)" class="pdf-text">
                  {{invoice.invoiceNumber }}</a>
              </ng-template>

            </div>
          </td>
          <td class="status-txt">
            <div *ngFor="let tracking of data.tracking">
              <a class="pdf-text tracking-link" href="{{ tracking?.trackingURL }}" target="_blank">
                {{tracking?.trackingNumber }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table aria-describedby="ordersTable" id="applyOrdersTable" class="credits-table table table-striped">
      <tr class="sample-header">
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
      <tr *ngFor="let data of ordersList; let i = index">
        <td class="two-column-lay header">
          {{ "accountOrders.date_label" | cxTranslate }}
        </td>
        <td class="two-column-lay">
          {{ data?.createdOn }}
        </td>
        <td class="two-column-lay header">Type</td>
        <td class="two-column-lay">
          {{ data?.orderType }}
        </td>
        <td class="two-column-lay header">
          {{ "accountOrders.order_no_label" | cxTranslate }}
        </td>
        <td class="two-column-lay">
          <a *ngIf="data.statusDisplay!='Cancelled';else cancelledOrder"
            [routerLink]="['/my-account/order', data?.code]" href="javascript: void(0);">
            {{ data?.code }}</a>
          <ng-template #cancelledOrder>
            {{ data.code }}
          </ng-template>
        </td>
        <td class="two-column-lay header">Account</td>
        <td class="two-column-lay">
          {{ data.shipToId }}
        </td>
        <td class="two-column-lay header">
          {{ "accountOrders.order_status_label" | cxTranslate }}
        </td>
        <td class="two-column-lay status-txt">{{ data?.statusDisplay }}</td>
        <td class="two-column-lay header">
          {{ "accountOrders.order_po_num_label" | cxTranslate }}
        </td>
        <td class="two-column-lay po-size" [ngClass]="{
            'po-more-list':
              !!data?.purchaseOrderNumber &&
              data?.purchaseOrderNumber?.length > 20
          }">
          {{ data?.purchaseOrderNumber }}
        </td>
        <td class="two-column-lay header">Invoice #</td>
        <td class="two-column-lay"></td>
        <td class="two-column-lay header">Tracking #</td>
        <td class="two-column-lay">
          <div *ngFor="let tracking of data.tracking">
            <a class="pdf-text tracking-link" href="{{ tracking?.trackingURL }}" target="_blank">
              {{tracking?.trackingNumber }}
            </a>
          </div>
        </td>
      </tr>
    </table>
  </section>
  <!--table ends-->
  <div class="invoice-btngrps" *ngIf="isLoadingDone">
    <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424"
      [routerLink]="['/my-account/orders']">
      {{ "accountOrders.button_text" | cxTranslate }}
    </button>

    <button *ngIf="isAsmUser || isUserApprover" type="button" class="btn-primary ml-4 approve-btn"
      [routerLink]="['/my-company/pending-orders']">
      View order approvals
    </button>
  </div>
</div>